<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <tabela :items="items" :loading="loading" @rechargeTable="getAll()" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import TaxaMediaDepreciacaoService from '@/services/TaxaMediaDepreciacaoService';
  import pusherMixins from '@/mixins/pusherMixins';
  import dayjs from 'dayjs';

  export default {
    components: {
      Tabela: () => import('@/components/taxaMediaDepreciacao/Tabela.vue')
    },
    mixins: [pusherMixins],

    data: () => ({
      items: [],
      loading: false
    }),

    mounted() {
      this.subscribe();
      this.getAll();
    },

    methods: {
      subscribe() {
        this.pusherChannel.bind('refreshTaxasMediasDepreciacao', () => {
          this.getAll();
        });
      },

      getAll() {
        this.loading = true;

        TaxaMediaDepreciacaoService.getAll()
          .then(({ data }) => {
            this.items = [];
            data.data.forEach((val) => {
              this.items.push({
                id: val.id,
                titulo: val.titulo,
                data_base: dayjs(val.data_base.split('T')[0]).format('DD/MM/YYYY'),
                status: val.status,
                usuario: val.usuario.nome,
                usuario_id: val.usuario.id,
                created: val.created,
                data_processamento: val.data_processamento ? dayjs(val.data_processamento).format('DD/MM/YYYY HH:mm') : '-'
              });
            });
          })
          .catch(() => {
            this.$toast.error('Erro ao recuperar as Taxas Médias de Depreciação.', '', { position: 'topRight' });
          })
          .finally(() => {
            this.loading = false;
          });
      }
    }
  };
</script>